import { compose } from 'recompose';
import { withRefs } from '../../../../utils/enchancers';
import { CoWorkers } from './CoWorkers';

const enhance = compose(
  withRefs(),
);
export default enhance(CoWorkers);
